import { STORE_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import store from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { ChatComunication } from "@/modules/Home/components/ChatWindow/Model/ChatComunication.model";
import {
  LOCAL_CHAT_TOOLTIP,
  LOCAL_CHAT_ACTIONS
} from "@/modules/Home/components/LocalChatWindow/constants/LocalChatWindow.constants";

@Component({
  name: "Chat",
  computed: {
    ...mapGetters({
      chatAction: "getChatComunication"
    })
  }
})
export default class Chat extends Vue {
  btnClassTertiary = STYLE_CLASSES.TERTIARY_BTN;
  toggle = false;
  error = "";
  text = "";
  ACTIONS = LOCAL_CHAT_ACTIONS;
  CHAT_TOOLTIP = LOCAL_CHAT_TOOLTIP;
  chatAction!: ChatComunication;

  openChat() {
    this.sendToMainView(this.ACTIONS.OPEN_CHAT);
  }
  sendToMainView(action: string) {
    const chatAction: ChatComunication = {
      action: action
    };
    store.commit(STORE_CONSTANTS.CHAT_ACTION, chatAction);
  }

  @Watch("chatAction")
  handleChatAction() {
    if (
      this.chatAction.action != "" &&
      this.chatAction.action == this.ACTIONS.CLOSE_CHAT
    ) {
      this.toggle = false;
      store.commit(STORE_CONSTANTS.CHAT_ACTION, { action: "" });
      return;
    }
  }
}
